















// 'use client';

// import React, { useState, useEffect, useRef } from 'react';
// import { useParams, useSearchParams } from 'react-router-dom';
// import { 
//   BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, 
//   Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell 
// } from 'recharts';

// import { 
//   Menu, X, Home, BarChart3, Users, Settings, LogOut, 
//   TrendingUp, DollarSign, Activity, UserPlus 
// } from 'lucide-react';

// import { BiSolidOffer } from 'react-icons/bi';

// // Import your sub-components
// import Homes from './parentFolders/Home';
// import Applications from './parentFolders/Applications';
// import Benefit from './parentFolders/Benefit';
// import MyDetails from './parentFolders/MyDetails';
// import Profile from './parentFolders/Profile';
// import Search from './parentFolders/Search';
// import Notifications from './parentFolders/Notifications';
// import EmployerEmployeeJobSeeker from '../EmployerEmployeeJobSeeker';
// import UserEngagementFeed from './parentFolders/FollowedJob';
// import { Link } from 'react-router-dom';
// import Logo from "../../../assets/ejobs-logo.svg";
// import ChangePassword from "../ChangePassword"
// export default function JobSeekerDashboard() {
//   const { id } = useParams();                    // Get :id from /profile/:id
//   const [searchParams, setSearchParams] = useSearchParams();
  
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const waveCanvasRef = useRef(null);

//   // Get active tab from URL query parameter, default to 'home'
//   const activeContent = searchParams.get('tab') || 'home';

//   // Analytics data (you can make this dynamic later)
//   const analyticsData = [
//     { name: 'Jan', revenue: 4000, users: 2400 },
//     { name: 'Feb', revenue: 3000, users: 1398 },
//     { name: 'Mar', revenue: 2000, users: 9800 },
//     { name: 'Apr', revenue: 2780, users: 3908 },
//     { name: 'May', revenue: 1890, users: 4800 },
//     { name: 'Jun', revenue: 2390, users: 3800 },
//   ];

//   const menuItems = [
//     { id: 'home', label: 'Home', icon: Home },
//     { id: 'analytics', label: 'Applied Jobs', icon: BarChart3 },
//     { id: 'benefits', label: 'Benefits', icon: BarChart3 },
//     { id: 'my-details', label: 'My Details', icon: BarChart3 },
//     { id: 'profile', label: 'My Profile', icon: BarChart3 },
//     { id: 'employee', label: 'My Employee Data', icon: BarChart3 },
//     { id: 'search', label: 'My Search', icon: BarChart3 },
//     { id: 'notifications', label: 'Notifications', icon: BarChart3 },
//     { id: 'followed-Jobs', label: 'Followed Jobs', icon: BiSolidOffer },
//     { id: 'change-password', label: 'Change Password', icon: BiSolidOffer },
//   ];

//   // Water Wave Canvas Animation
//   useEffect(() => {
//     const canvas = waveCanvasRef.current;
//     if (!canvas) return;

//     const ctx = canvas.getContext('2d');
//     let animationFrameId;
//     let phase = 0;

//     const drawWave = () => {
//       ctx.clearRect(0, 0, canvas.width, canvas.height);
      
//       // First wave layer
//       ctx.fillStyle = 'rgba(249, 115, 22, 0.2)';
//       ctx.beginPath();
//       ctx.moveTo(0, canvas.height);

//       for (let x = 0; x < canvas.width; x++) {
//         const y = canvas.height / 2 + Math.sin(x * 0.02 + phase) * 20;
//         ctx.lineTo(x, y - 40); // wave height
//       }

//       ctx.lineTo(canvas.width, canvas.height);
//       ctx.closePath();
//       ctx.fill();

//       // Gradient overlay
//       const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
//       gradient.addColorStop(0, 'rgba(249, 115, 22, 0.5)');
//       gradient.addColorStop(1, 'rgba(249, 115, 22, 0.1)');
//       ctx.fillStyle = gradient;
//       ctx.fill();

//       phase += 0.05;
//       animationFrameId = requestAnimationFrame(drawWave);
//     };

//     drawWave();

//     return () => cancelAnimationFrame(animationFrameId);
//   }, []);

//   const handleMenuClick = (tabId) => {
//     setSearchParams({ tab: tabId });
//     setSidebarOpen(false); // Close mobile sidebar
//   };

//   const renderContent = () => {
//     switch (activeContent) {
//       case 'home':
//         return <Homes waveCanvasRef={waveCanvasRef} />;
//       case 'analytics':
//         return <Applications />;
//       case 'benefits':
//         return <Benefit />;
//       case 'my-details':
//         return <MyDetails />;
//       case 'profile':
//         return <Profile />;
//       case 'employee':
//         return <EmployerEmployeeJobSeeker />;
//       case 'search':
//         return <Search />;
//       case 'notifications':
//         return <Notifications />;
//       case 'followed-Jobs':
//         return <UserEngagementFeed />;
//       case 'change-password':
//         return <ChangePassword />;
//       default:
//         return <Homes waveCanvasRef={waveCanvasRef} />;
//     }
//   };

//   // Get current tab label for header
//   const currentTabLabel = menuItems.find(item => item.id === activeContent)?.label || 'Home';

//   return (
//     <div className="flex h-screen bg-gray-100 dark:bg-gray-900">
//       {/* Sidebar */}
//       <aside
//         className={`
//           ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} 
//           md:translate-x-0 
//           fixed md:static inset-y-0 left-0 z-50 
//           w-64 bg-[#F97316] text-white 
//           transition-transform duration-300 ease-in-out
//           min-h-screen overflow-y-auto
//         `}
//       >
//         <div className="flex items-center justify-between p-6 border-b border-orange-600">
//           <Link to="/" className="flex-shrink-0">
//             <img
//               src={Logo}
//               alt="Essential Jobs Nigeria"
//               className="h-8 sm:h-10 w-auto bg-white rounded-sm p-1"
//             />
//           </Link>

//           <button
//             onClick={() => setSidebarOpen(false)}
//             className="md:hidden text-white hover:text-orange-200"
//           >
//             <X className="w-6 h-6" />
//           </button>
//         </div>

//         <nav className="flex-1 p-4">
//           <ul className="space-y-2">
//             {menuItems.map((item) => {
//               const Icon = item.icon;
//               const isActive = activeContent === item.id;

//               return (
//                 <li key={item.id}>
//                   <button
//                     onClick={() => handleMenuClick(item.id)}
//                     className={`w-full flex items-center p-3 rounded-lg transition-all ${
//                       isActive
//                         ? 'bg-white text-orange-500 shadow-lg font-medium'
//                         : 'hover:bg-orange-600'
//                     }`}
//                   >
//                     <Icon className="w-5 h-5 mr-3" />
//                     {item.label}
//                   </button>
//                 </li>
//               );
//             })}
//           </ul>
//         </nav>
//       </aside>

//       {/* Main Content Area */}
//       <div className="flex-1 flex flex-col">
//         {/* Header */}
//         <header className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
//           <div className="flex items-center justify-between p-4">
//             <button
//               onClick={() => setSidebarOpen(true)}
//               className="md:hidden text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100"
//             >
//               <Menu className="w-6 h-6" />
//             </button>

//             <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 capitalize">
//               {''}
//             </h2>
//             <Link to ='/'>
//                <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 capitalize">
//               Back
//             </h2>
//             </Link>
         

//             <Link to="/signin">
//               <button className="flex items-center gap-2 px-4 py-2 rounded-lg hover:bg-orange-50 dark:hover:bg-gray-700 transition">
//                 <LogOut className="w-5 h-5" />
//                 <span>Logout</span>
//               </button>
//             </Link>
//           </div>
//         </header>

//         {/* Page Content */}
//         <main className="flex-1 p-6 overflow-y-auto bg-gray-100 dark:bg-gray-900">
//           {renderContent()}
//         </main>
//       </div>

//       {/* Mobile Overlay */}
//       {sidebarOpen && (
//         <div
//           className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
//           onClick={() => setSidebarOpen(false)}
//         />
//       )}
//     </div>
//   );
// }



'use client';

import React, { useState, useEffect, useRef } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { 
  BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, 
  Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell 
} from 'recharts';

import { 
  Menu, X, Home, BarChart3, Users, Settings, LogOut, 
  TrendingUp, DollarSign, Activity, UserPlus, Bell, User, ChevronDown 
} from 'lucide-react';

import { BiSolidOffer } from 'react-icons/bi';
import { useSelector } from 'react-redux';

// Import your sub-components
import Homes from './parentFolders/Home';
import Applications from './parentFolders/Applications';
import Benefit from './parentFolders/Benefit';
import MyDetails from './parentFolders/MyDetails';
import Profile from './parentFolders/Profile';
import Search from './parentFolders/Search';
import Notifications from './parentFolders/Notifications';
import EmployerEmployeeJobSeeker from '../EmployerEmployeeJobSeeker';
import UserEngagementFeed from './parentFolders/FollowedJob';
import { Link } from 'react-router-dom';
import Logo from "../../../assets/ejobs-logo.svg";
import ChangePassword from "../ChangePassword"
import InterviewTips from './InterviewTips';

export default function JobSeekerDashboard() {
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const loggedInUser = useSelector((state) => state.user?.currentUser);

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);
  const waveCanvasRef = useRef(null);

  const activeContent = searchParams.get('tab') || 'home';

  const analyticsData = [
    { name: 'Jan', revenue: 4000, users: 2400 },
    { name: 'Feb', revenue: 3000, users: 1398 },
    { name: 'Mar', revenue: 2000, users: 9800 },
    { name: 'Apr', revenue: 2780, users: 3908 },
    { name: 'May', revenue: 1890, users: 4800 },
    { name: 'Jun', revenue: 2390, users: 3800 },
  ];

  const menuItems = [
    { id: 'home', label: 'Home', icon: Home },
    { id: 'analytics', label: 'Applied Jobs', icon: BarChart3 },
    { id: 'benefits', label: 'Benefits', icon: BarChart3 },
    { id: 'my-details', label: 'My Details', icon: BarChart3 },
    { id: 'profile', label: 'My Profile', icon: BarChart3 },
    { id: 'employee', label: 'My Employee Data', icon: BarChart3 },
    { id: 'search', label: 'My Search', icon: BarChart3 },
    { id: 'tips', label: 'Interview Tips', icon: BarChart3 },
    // { id: 'notifications', label: 'Notifications', icon: BarChart3 },
    { id: 'followed-Jobs', label: 'Followed Jobs', icon: BiSolidOffer },

    { id: 'change-password', label: 'Change Password', icon: BiSolidOffer },
  ];

  // Water Wave Canvas Animation
  useEffect(() => {
    const canvas = waveCanvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    let animationFrameId;
    let phase = 0;

    const drawWave = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      ctx.fillStyle = 'rgba(249, 115, 22, 0.2)';
      ctx.beginPath();
      ctx.moveTo(0, canvas.height);

      for (let x = 0; x < canvas.width; x++) {
        const y = canvas.height / 2 + Math.sin(x * 0.02 + phase) * 20;
        ctx.lineTo(x, y - 40);
      }

      ctx.lineTo(canvas.width, canvas.height);
      ctx.closePath();
      ctx.fill();

      const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
      gradient.addColorStop(0, 'rgba(249, 115, 22, 0.5)');
      gradient.addColorStop(1, 'rgba(249, 115, 22, 0.1)');
      ctx.fillStyle = gradient;
      ctx.fill();

      phase += 0.05;
      animationFrameId = requestAnimationFrame(drawWave);
    };

    drawWave();
    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  // Close the user dropdown when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
        setUserMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleMenuClick = (tabId) => {
    setSearchParams({ tab: tabId });
    setSidebarOpen(false);
    setUserMenuOpen(false);
  };

  const renderContent = () => {
    switch (activeContent) {
      case 'home':
        return <Homes waveCanvasRef={waveCanvasRef} />;
      case 'analytics':
        return <Applications />;
      case 'benefits':
        return <Benefit />;
      case 'my-details':
        return <MyDetails />;
      case 'profile':
        return <Profile />;
      case 'employee':
        return <EmployerEmployeeJobSeeker />;
      case 'search':
        return <Search />;
      case 'tips':
        return <InterviewTips />;
      case 'notifications':
        return <Notifications />;
      case 'followed-Jobs':
        return <UserEngagementFeed />;
      case 'change-password':
        return <ChangePassword />;
      default:
        return <Homes waveCanvasRef={waveCanvasRef} />;
    }
  };

  const currentTabLabel = menuItems.find((item) => item.id === activeContent)?.label || 'Home';

  return (
    <div className="flex h-screen bg-gray-100 dark:bg-gray-900">
      {/* Sidebar */}
      <aside
        className={`
          ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} 
          md:translate-x-0 
          fixed md:static inset-y-0 left-0 z-50 
          w-64 bg-[#F97316] text-white 
          transition-transform duration-300 ease-in-out
          min-h-screen overflow-y-auto
        `}
      >
        <div className="flex items-center justify-between p-6 border-b border-orange-600">
          <Link to="/" className="flex-shrink-0">
            <img
              src={Logo}
              alt="Essential Jobs Nigeria"
              className="h-8 sm:h-10 w-auto bg-white rounded-sm p-1"
            />
          </Link>

          <button
            onClick={() => setSidebarOpen(false)}
            className="md:hidden text-white hover:text-orange-200"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <nav className="flex-1 p-4">
          <ul className="space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = activeContent === item.id;

              return (
                <li key={item.id}>
                  <button
                    onClick={() => handleMenuClick(item.id)}
                    className={`w-full flex items-center p-3 rounded-lg transition-all ${
                      isActive
                        ? 'bg-white text-orange-500 shadow-lg font-medium'
                        : 'hover:bg-orange-600'
                    }`}
                  >
                    <Icon className="w-5 h-5 mr-3" />
                    {item.label}
                  </button>
                </li>
              );
            })}
          </ul>
        </nav>
      </aside>

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col">
        {/* Header */}
        <header className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center justify-between p-4">
            <button
              onClick={() => setSidebarOpen(true)}
              className="md:hidden text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100"
            >
              <Menu className="w-6 h-6" />
            </button>

            <Link to="/" className="hidden md:block">
              <h2 className="text-sm font-semibold text-gray-600 dark:text-gray-300 hover:text-orange-500 transition">
                ← Back
              </h2>
            </Link>

            {/* Right-side icon cluster */}
            <div className="flex items-center gap-2 ml-auto">
              {/* Notification bell */}
              <button
                onClick={() => handleMenuClick('notifications')}
                className={`relative p-2 rounded-full transition ${
                  activeContent === 'notifications'
                    ? 'bg-orange-50 text-orange-500'
                    : 'text-gray-600 dark:text-gray-300 hover:bg-orange-50 hover:text-orange-500 dark:hover:bg-gray-700'
                }`}
                aria-label="Notifications"
              >
                <Bell className="w-5 h-5" />
                {/* Wire this to your real unread count when available, e.g.:
                    {unreadCount > 0 && (
                      <span className="absolute -top-0.5 -right-0.5 w-4 h-4 flex items-center justify-center text-[10px] font-bold bg-red-500 text-white rounded-full">
                        {unreadCount > 9 ? '9+' : unreadCount}
                      </span>
                    )}
                */}
              </button>

              {/* User avatar + dropdown */}
              <div className="relative" ref={userMenuRef}>
                <button
                  onClick={() => setUserMenuOpen((open) => !open)}
                  className="flex items-center gap-1.5 p-1.5 pr-2 rounded-full hover:bg-orange-50 dark:hover:bg-gray-700 transition"
                  aria-haspopup="true"
                  aria-expanded={userMenuOpen}
                >
                  {loggedInUser?.avatar ? (
                    <img
                      src={loggedInUser.avatar}
                      alt={loggedInUser?.firstName || 'User'}
                      className="w-8 h-8 rounded-full object-cover border border-gray-200"
                    />
                  ) : (
                    <div className="w-8 h-8 rounded-full bg-orange-100 text-orange-500 flex items-center justify-center">
                      <User className="w-4 h-4" />
                    </div>
                  )}
                  <ChevronDown
                    className={`w-4 h-4 text-gray-500 transition-transform ${userMenuOpen ? 'rotate-180' : ''}`}
                  />
                </button>

                {userMenuOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-100 dark:border-gray-700 py-1 z-50">
                    {loggedInUser && (
                      <div className="px-4 py-2 border-b border-gray-100 dark:border-gray-700">
                        <p className="text-sm font-medium text-gray-800 dark:text-gray-100 truncate">
                          {loggedInUser.firstName} {loggedInUser.lastName}
                        </p>
                        <p className="text-xs text-gray-500 truncate">{loggedInUser.email}</p>
                      </div>
                    )}
                    <button
                      onClick={() => handleMenuClick('profile')}
                      className="w-full flex items-center gap-2 px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-orange-50 dark:hover:bg-gray-700 transition"
                    >
                      <User className="w-4 h-4" />
                      My Profile
                    </button>
                    <Link
                      to="/signin"
                      className="w-full flex items-center gap-2 px-4 py-2 text-sm text-red-500 hover:bg-red-50 dark:hover:bg-gray-700 transition"
                    >
                      <LogOut className="w-4 h-4" />
                      Logout
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 p-6 overflow-y-auto bg-gray-100 dark:bg-gray-900">
          {renderContent()}
        </main>
      </div>

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
}